import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const headings = document.querySelectorAll(".scrolling-heading");
// const nums = document.querySelectorAll('.scroll-num');
const head = document.querySelector(".head");
const posts = document.querySelector(".sweat-posts");

const numOfTransitions = headings.length;

const singleDuration = 300;
const totalDuration = singleDuration * numOfTransitions;

if (head) {
  gsap.to(".head", {
    scrollTrigger: {
      pin: ".head",
      end: "+=" + `${totalDuration}s`,
      onLeave: () => {
        head.style.transform = "translate(0px, 0px)";
      },
      onComplete: () => {
        head.style.transform = "translate(0px, 0px)";
      },
      pinSpacing: true,
    },
  });
}

if (posts) {
  gsap.to(".heading-inner-last", {
    opacity: 1,
    duration: 1,
    scale: 0.5,
    scrollTrigger: {
      trigger: ".sweat-posts",
      scrub: true,
      // pinnedContainer: ".head",
      // pin: "main",
      start: "top 80%",
      end: "top center",
      toggleActions: "play none none reverse",
    },
  });
}

if (headings) {
headings.forEach((heading, i) => {
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: "heading",
      toggleActions: "play reverse play reverse",
      start: "+=" + `${singleDuration * i}s`,
      end: "+=" + `${singleDuration}s`,
      // markers: false,
      onEnter: () => {
        gsap.to([heading], { opacity: 1 });
      },
      onLeave: () => {
        if (i !== headings.length - 1) {
          gsap.to([heading], { opacity: 0 });
        }
      },
      onEnterBack: () => {
        gsap.to([heading], { opacity: 1 });
      },
      onLeaveBack: () => {
        if (i === 0) return;
        gsap.to([heading], { opacity: 0, duration: 1 });
      },
    },
  });
});
}

const sweatBoxes = gsap.utils.toArray(".sweat-box");

sweatBoxes.forEach((box) => {
  const dataIndex = box.dataset.index;

  var range = box.dataset.range;
  var start = box.dataset.start;
  var end = box.dataset.end;

  // if(box.dataset.col == 1 && dataIndex == 1){
  //   range = -100;
  // }
  // if(box.dataset.col == 2 && dataIndex == 1){
  //   range = -60;
  // }

  // console.log(dataIndex);

  gsap.to(box, {
    scrollTrigger: {
      trigger: box,
      // toggleActions: 'play reverse',
      start: start,
      end: end,
      scrub: 1,
      // markers: true,
    },
    // yPercent: range,
    y: range,
    // transform: `translateY(${range})`,
    // top: `${range}px`,
    duration: 1.5,
    overwrite: "auto",
    ease: "float",
  });
});

//   if(dataIndex && dataIndex < 2) {
//     ScrollTrigger.create({
//       trigger: box,
//       start: "top 100%",
//       end: "bottom 50%",
//       scrub: 1,
//       onEnter: slide,
//       // onLeave: self => slide(self, range ,false),
//       onEnterBack: slide,
//       onLeaveBack: slide,
//       markers: true
//     });
//   }
// })

function slide(st, range = 50, forceToEnd) {
  let backwards = st.direction < 0;
  if (st.animBackwards !== backwards) {
    st.animBackwards = backwards;
    st.anim && st.anim.kill(); // kill any old animation
    st.anim = gsap.to(st.trigger, {
      yPercent: backwards ? 0 : `-${range}`,
      top: backwards ? "0%" : `${range}%`,
      duration: 1.5,
      overwrite: "auto",
      ease: "float",
    });
  }
  if (forceToEnd) {
    st.anim.progress(1);
  }
}

// ScrollTrigger.create({
//   trigger: '.sweat-posts',        // Element to trigger the animation
//   start: 'top 80%', // Animation start point
//   end: 'bottom top',   // Animation end point
//   markers: true,
//   onUpdate: (self) => {
//     // Get the scroll velocity (positive or negative)
//     const velocity = Math.abs(self.getVelocity()) / 1000; // Normalize velocity

//     // Shrink and fade-out effect
//     gsap.to(head, {
//       scale: Math.max(1 - velocity, 0.1),  // Shrink based on velocity, minimum scale of 0.1
//       opacity: Math.max(1 - velocity, 0.1), // Fade-out based on velocity, minimum opacity of 0.1
//       duration: 0.1,                        // Adjust the duration to make it smooth
//     });
//   }
// });

// const sweatPosts = document.querySelector(".sweat-posts");

// if (sweatPosts) {

//     var percertange;
//     var visiblePx;

//     const fadingEl = head;
//     // fadingEl
//     // fadingEl.classList.add('fadeInGrow');
//     const intersectionCallback = (entries) => {
//         entries.forEach((entry) => {

//             if (entry.isIntersecting) {
//                 let elem = entry.target;
//                 // console.log(window.innerHeight - elem.getBoundingClientRect().top);
//                 visiblePx = window.innerHeight - elem.getBoundingClientRect().top
//                 percertange =  100 - visiblePx;
//                 // if(percertange > 0 && percertange <= 100){
//                     fadingEl.style.opacity = percertange / 100;
//                     fadingEl.style.transform = `scale(${percertange / 100 / 2})`;
//                 // }
//                 // console.log(elem.getBoundingClientRect());
//                 // if(visiblePx > 220){
//                 //     fadingEl.classList.contains('fadeInGrow') ? fadingEl.classList.remove('fadeInGrow') : false;
//                 //     !fadingEl.classList.contains('fadeInGrow') ? fadingEl.classList.add('fadeOutShrink') : false;

//                 // } else {
//                 //     fadingEl.classList.remove('fadeOutShrink');
//                 //     fadingEl.classList.add('fadeInGrow');
//                 // }

//                 // console.log(elem.getBoundingClientRect());
//                 // console.log(elem.getBoundingClientRect().top);
//                 // console.log(elem.getBoundingClientRect().bottom);
//                 // if (entry.intersectionRatio >= 0.25) {

//                 // }
//             }
//         });
//     };

//     const options = {
//         root: null,
//         rootMargin: "0px",
//         threshold: [],
//     };

//     for (let i = 0; i <= 1.0; i += 0.01) {
//         options.threshold.push(i);
//     }

//     const observer = new IntersectionObserver(intersectionCallback, options);

//     observer.observe(sweatPosts);
// }
